"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getEIP712Domain = void 0;
const utils_1 = require("ethers/lib/utils");
const getEIP712Domain = (payload, config) => {
    return {
        name: "GelatoRelayERC2771",
        version: "1",
        chainId: payload.chainId,
        verifyingContract: (0, utils_1.getAddress)(config.contract.relayERC2771),
    };
};
exports.getEIP712Domain = getEIP712Domain;
